interface OutlinePersonIconProps {
    color: string
    height: string
    width: string
}
export const OutlinePersonIcon = ({
    width,
    color,
    height
}: OutlinePersonIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M12 22C17.5228 22 22 17.5229 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22Z"
                stroke={color}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19 19V17.9663C19 17.0079 19 16 17.5 15.5L13.5 14V13C14.5 12.5 15 11.5 15 10.5V8C15 6 13.5786 5 12 5C10.4214 5 9 6 9 8V10.5C9 11.5 9.5 12.5 10.5 13V14L6.5 15.5C5 16 5 17.0735 5 18.0202V19"
                stroke={color}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
